import { Button, Col, Row } from "react-bootstrap";
import { FileUpload } from "../../../../../../components/FileUpload";
import useUploadDocumentFormPayload from "./hooks/useUploadDocumentFormPayload";
import NotyfContext from "../../../../../../contexts/NotyfContext";
import { useContext } from "react";

export default function UploadDocumentForm(){
    
    const {
        invoiceData,
        payload,
        canInsert,
        handleChangeFile,
        onSubmit,
    } = useUploadDocumentFormPayload()
    
    const notyf = useContext(NotyfContext)

    return (
        <Row className="p-5">
            <Row>
                <h3 className="mb-3">Attach your files here</h3>
                <h4 className="text-info mb-2">Note:</h4>
                <ul>
                    <li>Only <b className="text-danger">{invoiceData?.max_submission} files</b> per invoice is allowed.</li>
                    <li>The size of each file must be <b className="text-danger">{invoiceData?.max_size_allowed} MB each</b>.</li>
                    <li>Listed below are the only <b className="text-danger">file extensions allowed</b>: <br/>
                        <ul style={{columnCount: 2}}>
                            {invoiceData?.file_types_allowed?.map((data) => (
                                <li>{data}</li>
                            ))}
                        </ul>
                    </li>
                </ul>

                <FileUpload 
                    files={payload?.files}
                    setFiles={handleChangeFile}
                    maxFiles={10}
                    className="fileupload-bg"
                    onWarning={( body ) => notyf?.error(`${body === 'Max files' ? 'Max files reached.' : body }`)}
                    disabled={!canInsert}
                />
            </Row>
            <Row className="d-flex justify-content-end">
                <Col style={{gap: '0.4rem'}} className="d-flex justify-content-end">
                    <Button onClick={onSubmit} disabled={payload?.length == 0 || !canInsert}>
                        Submit
                    </Button>
                </Col>
            </Row>
        </Row>
    )
}